module.exports = __webpack_public_path__ + "static/img/service_cont_05_zh.cf48e2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_cont_05_zh.png
// module id = nTvG
// module chunks = 34